// TODO: the file uploader should be bundled here but it is not working
// const jQuery = window.jQuery;
// const $ = window.$;
// import 'blueimp-file-upload';
import { createGlobalUploader } from './global-uploader';
import 'blueimp-file-upload';
import { assertIsFunction } from '../../lib/test-and-assert/assert-base';

import { globalLogger } from '../../qaamgo/helper/global-logger';
import '../../lib/logger/logger';

import { conversionOptions } from '../conversion-options/conversion-options';
import { pageNotification } from '../../qaamgo/helper/notify';
import { ApiConfig } from '../api/api';
import { Uploader } from './core/uploader';
import { createSatUi } from './file-list/ui';
import { INPUT_STATUS_UPLOADER_DONE, INPUT_TYPE_EXTERNAL_URL, INPUT_TYPE_FILE_UPLOAD } from './core/consts';
import {
    GLOBAL_EVENT_JOB_CREATE_DONE,
    GLOBAL_EVENT_JOB_CREATE_FAIL,
    INPUT_EVENT_DELETED,
    INPUT_EVENT_DONE,
    INPUT_EVENT_FAIL,
    INPUT_EVENT_LOADING,
    INPUT_EVENT_PASSWORD_MISSING,
    INPUT_EVENT_SUBMITTING,
    INPUT_EVENT_UPLOAD_CANCELED,
    HIDE_OPTIONS_EVENT,
    SHOW_OPTIONS_EVENT,
    UPLOADER_EVENT,
    STOP_AUTO_START_UPLOAD,
    AUTO_START_UPLOAD_STOPPED,
} from './core/event';
import {API_ERROR_PAYMENT_REQUIRED} from '../api/consts';
import {
    testIsArray,
    testIsFalseish,
    testIsNonEmptyString,
    testIsNull,
    testIsNumber,
    testIsTrimmedStringNotEmpty,
    testIsTrueish,
    testIsUndefined,
    testIsUUID4,
} from '../../lib/test-and-assert/test-base';
import { translate } from '../../qaamgo/helper/translate';
import { satGlobals } from '../../qaamgo/sat/helper/sat-globals';
import { captcha } from '../captcha/sat-captcha';
import { getValueFromCurrentUrl } from '../../qaamgo/helper/query-fragment-params';
import { AjaxWrapper } from '../../lib/ajax/ajax-wrapper';
import { JobInfoHelper } from './core/info-helper/job-info-helper';
import { pageSizes } from '../../qaamgo/helper/page_sizes';
import { isMobile } from '../misc/browser-detector';
import downloadengine from '../../qaamgo/modules/sat/components/download-engine';
import UploaderCreditDisplay from '../../qaamgo/modules/sat/components/UploaderCreditDisplay';
import { eventBus } from '../../lib/event-bus/event-bus';
import { assertIsUploaderEvent } from './core/assert';
import { testIsGlobalEvent, testIsInputEvent } from './core/test';
import { VUE_NO_UPLOADER_START_CLICK } from './event';
import { limitReachedStartConversion } from '../limits/main-limits';
import { LIMIT_FEATURE_IS_PREMIUM } from '../limits/limits';
import { useUploaderStore } from '../store/modules/uploader-store';
import { DEFAULT_PROMPT, SURPRISE_ME_PROMPTS } from './prompts';
import { bytesToBase64, decodeBase64ToImageUrl, encodeImageToBase64 } from '../../qaamgo/helper/base64';
import { userManager } from '../user/user-manager';

import { createApp, ref, defineComponent, h } from 'vue';

const $ = require('jquery');
global.$ = global.jQuery = $;

/** @type {Uploader|null} */
var uploader = null;

/** @type {Api|null} */
var api = null;

var captchaKey = '';

const ocConversionOptionsMapping = {
    audio_start: 'start',
    audio_end: 'end',
    video_start: 'start',
    video_end: 'end',
    dpg_version: 'version',
    asciiize: 'ascii',
    channel: 'channels',
    bit_depth: 'audio_bitdepth',
    video_target_size: 'file_size',
    input_encoding: 'encoding',
    audio_quality: 'audio_bitrate',
    rate: 'framerate',
    video_codec: 'codec',
    audio_channel: 'channel',
    bitrate: 'audio_bitrate',
    remove_background: 'alpha_channel',
};

class EngineHelper {
    constructor() {
        this._localIds = [];
        this._isProcessing = false;
    }

    /**
     * @param {Number} localId
     */
    add(localId) {
        this._localIds.push(localId);

        if (!this._isProcessing) {
            this._process();
        }
    }

    _process() {
        if (this._localIds.length === 0) {
            this._isProcessing = false;

            return;
        }

        this._isProcessing = true;

        const localId = this._localIds.shift();

        engineModal.show(localId);
    }

    isProcessing() {
        return this._isProcessing;
    }
}

const engineHelper = new EngineHelper();

class Modal {
    constructor() {
        this.app = null;

        this.isLoaded = new Promise((resolve) => {
            import(
                /* webpackMode: "lazy-once" */
                `../../entrypoints/translations/sat-translations.js`
            ).finally(() => {
                const downloadEngineAppEl = document.getElementById('downloadEngineApp');

                if (downloadEngineAppEl) {

                    const App = defineComponent({
                        name: 'UploaderDownloadEngineRoot',
                        components: {
                            downloadengine
                        },
                        setup(_, { expose }) {
                            const showModal = ref(false);
                            const localId = ref(null);

                            // Method to show the modal and set the localId
                            const show = (id) => {
                                localId.value = id;
                                showModal.value = true;
                            };

                            // Callback method to handle download engine events
                            const callback = (downloadEngine) => {
                                showModal.value = false;

                                if (downloadEngine === 'auto') {
                                    engineHelper._process();
                                    return;
                                }

                                const input = qgUploader.getInput(localId.value);
                                const remoteUrl = input.getSource();

                                uploader.dispatchInputEvent(INPUT_EVENT_LOADING, localId.value);

                                qgUploader.deleteInput(localId.value).done(() => {
                                    qgUploader.addExternalUrl(remoteUrl, downloadEngine);
                                    engineHelper._process();
                                });
                            };

                            expose({ show });

                            return {
                                showModal,
                                callback,
                                show
                            };
                        },
                        template: `<downloadengine :showModal="showModal" :callback="callback"       />`
                    });

                    this.app = createApp(App);
                    this.vm = this.app.mount('#downloadEngineApp')
                }

                resolve();
            });
        });
    }

    /**
     * @param {Number} localId
     */
    show(localId) {
        this.isLoaded.then(() => {
            this.vm.show(localId);
        });
    }
}

var startAfterUploaderReady = false;

const engineModal = new Modal();

var featureHelper = {
    disableSubmit: function () {
        $('.submit-btn')
            .prop('disabled', true)
            .find('.fa')
            .addClass('fa-spin btn-loading-animation lh-small')
            .removeClass('fa-arrow-right');

        startAfterUploaderReady = true;
        featureHelper.showStop();

        eventBus.emit(HIDE_OPTIONS_EVENT);
    },
    enableSubmit: function () {
        $('.submit-btn')
            .prop('disabled', false)
            .find('.fa')
            .removeClass('fa-spin btn-loading-animation lh-small')
            .addClass('fa-arrow-right');

        startAfterUploaderReady = false;
        featureHelper.showSubmit();

        eventBus.emit(SHOW_OPTIONS_EVENT);
    },
    showStop: function () {
        $('.submit-btn').addClass('d-none').removeClass('d-flex');
        $('.stop-btn').addClass('d-flex').removeClass('d-none');
    },
    showStopInProgress: function () {
        $('.stop-btn').prop('disabled', false);
    },
    showSubmit: function () {
        $('.submit-btn').addClass('d-flex').removeClass('d-none');
        $('.stop-btn').addClass('d-none').removeClass('d-flex');
    },
    defaultSubmitFunction: function () {
        const $remoteUrlInput = $('#remoteUrlInput');

        if ($remoteUrlInput.length === 1) {
            const externalUrl = $remoteUrlInput.val();

            $remoteUrlInput.val('');

            // check on trimmed string to prevent some random spaces in field
            if (testIsTrimmedStringNotEmpty(externalUrl)) {
                let engine = 'auto';

                const $inputEngine = $('#inputEngine');

                if ($inputEngine.length > 0 && testIsNonEmptyString($inputEngine.val())) {
                    engine = $inputEngine.val();
                }

                uploader.addExternalUrl(externalUrl, engine);
            }
        }

        const hashTextInput = $('#inputHashString').val();

        if (testIsNonEmptyString(hashTextInput)) {
            handleTextInput(hashTextInput);

            return;
        }

        if (uploader.isWaitingForPasswords()) {
            pageNotification.warning('Please enter the missing password(s)!');

            return;
        }

        if (!conversionOptions.isConversionOptionsFormValid('#sendform')) {
            return;
        }

        var data = conversionOptions.getConversionOptionsFromForm('#sendform', uploader);

        //scroll to uploader so user is aware of uploader state
        var uploadBoxMainWrapper = document.getElementById('uploadBoxMainWrapper');
        
        if (uploadBoxMainWrapper) {
            uploadBoxMainWrapper.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }

        if (data.target === 'compare-image' || data.target === 'compare-video' || data.target === 'merge-streams') {
            if (uploader.getInputList().getNumberOfAllValidInputs() < 2) {
                pageNotification.warning('Sorry you must add two files!');
                return;
            } else if (uploader.getInputList().getNumberOfAllValidInputs() > 2) {
                pageNotification.warning('Sorry you can not add more than two files!');
                return;
            }
        }

        try {
            qgFeaturePage.checkForBrokenSelects(data['target']);
        } catch (e) {
            globalLogger.log('exception in checkForBrokenSelects', e);
        }

        if (data) {
            if (!uploader.isEmpty()) {
                featureHelper.disableSubmit();
            }

            if (engineHelper.isProcessing() || uploader.getInputList().getNumberOfRemoteInputsForEngineCheck() > 0) {
                downloadEngineSubmit(() => {
                    featureHelper.startCaptcha();
                });

                return;
            }

            featureHelper.startCaptcha();
        } else {
            globalLogger.log('defaultSubmitFunction error - empty conversion options data');
        }
    },
    startCaptcha: function () {
        captcha
            ._checkCaptchaNeeded()
            .then(function (isCaptchaRequired) {
                if (isCaptchaRequired === false) {
                    featureHelper.waitUntilUploaderIsReady();
                } else {
                    captcha._startCaptcha(captchaKey, featureHelper.waitUntilUploaderIsReady);
                }
            })
            .fail(function () {
                globalLogger.log('startCaptcha error - check captcha needed failed');

                pageNotification.warning('Sorry, something went wrong. Please try again, or refresh the page.');
                featureHelper.enableSubmit();
            });
    },
    waitUntilUploaderIsReady: function () {
        if (!startAfterUploaderReady) {
            featureHelper.enableSubmit();
            return;
        }

        if (uploader.isEmpty()) {
            const uploaderStore = useUploaderStore();
            const displayLimitError = uploaderStore.getDisplayLimitError;

            // only show this message if no error is shown in uploader box
            // if (displayLimitError === null) {
            //     pageNotification.warning('Please add one or more files above!');
            // }

            featureHelper.enableSubmit();
            return;
        }

        if (uploader.isWaitingForPasswords()) {
            pageNotification.warning('Please enter the missing password(s)!');
            featureHelper.enableSubmit();
            return;
        }

        if (!uploader.isReadyToSubmit()) {
            setTimeout(function () {
                featureHelper.waitUntilUploaderIsReady();
            }, 500);
            return;

        }

        if (!conversionOptions.isConversionOptionsFormValid('#sendform')) {
            featureHelper.enableSubmit();
            return;
        }

        var data = conversionOptions.getConversionOptionsFromForm('#sendform', uploader);

        const target = data['target'];

        if (pageConfig.operation === 'resize') {
            if (target === 'png' || target === 'jpg' || target === 'gif') {
                data.options['compress'] = 'low';
            }
        }

        if (target === 'pdf' && data.options.file_size) {
            // send file_size in KB
            data.options['file_size'] = data.options.file_size * 1024;
        }

        globalLogger.log('modConversion add start', { info: JSON.stringify(data) });

        var forwardToResultPage = function () {
            window.allowLeave = true;

            window.location = satGlobals.getResultUrl() + '#j=' + uploader.getJob().getId();
        };

        api.addConversionWithCheck(uploader.getJob().getId(), data)
            .done(function (response) {
                globalLogger.log('modConversion add done', { info: JSON.stringify(data) });

                forwardToResultPage();
            })
            .fail(function (apiError, response) {
                if (apiError === API_ERROR_PAYMENT_REQUIRED) {
                    limitReachedStartConversion(response);

                    featureHelper.enableSubmit();

                    window.paymentConversion = { active: true };

                    return;
                }

                globalLogger.log('modConversion add fail', {
                    info: 'error: ' + apiError + ' data: ' + JSON.stringify(data),
                });

                forwardToResultPage();
            });
    },
    setupUploadButtons: function (uploader) {
        // hide the downloader_modal
        $('#downloaderOKButton').click(function (e) {
            e.stopPropagation();

            $('#selectDownloader').modal('hide');
        });

        $('#sendform').on('submit', function (event) {
            event.preventDefault();
        });
    },
};

/**
 * @param submitCallback {Function}
 */
function downloadEngineSubmit(submitCallback) {
    const startSeconds = Date.now() / 1000;

    function waitHandler() {
        if (engineHelper.isProcessing()) {
            setTimeout(() => {
                waitHandler();
            }, 500);

            return;
        }

        const durationSeconds = Date.now() / 1000 - startSeconds;

        if (durationSeconds >= 30) {
            submitCallback();

            return;
        }

        if (uploader.getInputList().getNumberOfRemoteInputsForEngineCheck() === 0) {
            submitCallback();

            return;
        }

        setTimeout(() => {
            waitHandler();
        }, 500);
    }

    waitHandler();
}

function handleAutoStart(pageConfig, event, localId) {
    if (!pageConfig.hasOwnProperty('autoStart')) {
        return;
    }

    var inputs = uploader.getInputList();

    if (event === INPUT_EVENT_PASSWORD_MISSING && inputs.getNumberOfPasswordMissing() >= 1) {
        pageNotification.warning('Please enter the missing password(s)!');

        return;
    }

    var inputChangedEvents = [INPUT_EVENT_DONE, INPUT_EVENT_DELETED, INPUT_EVENT_FAIL, INPUT_EVENT_UPLOAD_CANCELED];

    if (inputChangedEvents.indexOf(event) === -1) {
        return;
    }

    if (!uploader.isReadyToSubmit()) {
        return;
    }

    if (engineHelper.isProcessing() || uploader.getInputList().getNumberOfRemoteInputsForEngineCheck() > 0) {
        // we don't need a callback because autostart will be triggered
        // by the inputCallback event when the re-added input is done
        downloadEngineSubmit(() => {});

        return;
    }

    window.allowLeave = true;

    if (pageConfig.operation === 'merge system thumbnail') {
        function getInputsIds() {
            const list = uploader.getInputList();

            const inputs = list.getInputs();

            let inputIds = [];

            inputs.forEach((input) => {
                const inputId = input.getInputId();
                const isUUID4InputId = testIsUUID4(inputId);
                const isDone = input.getStatus() === INPUT_STATUS_UPLOADER_DONE;

                if (isUUID4InputId && isDone) {
                    inputIds.push(inputId);
                } else {
                    let info = '';

                    info += 'input id: ' + JSON.stringify(inputId) + ' ';
                    info += 'status: ' + input.getStatus();

                    globalLogger.log('feature page merge - input in invalid state', info);
                }
            });

            return inputIds;
        }

        const inputIds = getInputsIds();

        api.ajaxWrapper
            .postJson({
                url: satGlobals.getApiUrl('api/storage/input_ids'),
                xhrFields: {
                    withCredentials: true,
                },
                dataType: 'json',
                data: {
                    job_id: uploader.getJob().getId(),
                    input_ids: inputIds,
                },
                cache: false,
                maxRetries: 3,
            })
            .done(function (data) {
                //Do not redirect to the editor if the payment modal is visible
                if ($('#authModal').is(':visible')) {
                    return;
                }

                if (data.id) {
                    window.location = pageConfig.autoStart.target + '#j=' + data.id;

                    return;
                }

                pageNotification.error('Sorry, something went wrong. Please try again, or refresh the page.');
            })
            .fail(function () {
                pageNotification.error('Sorry, something went wrong. Please try again, or refresh the page.');
            });

        return;
    }

    var hasConversion = pageConfig.autoStart.hasOwnProperty('conversion');

    // some advanced feature pages (e.g. some pdf editors) use the initial job just to
    // collect some input files and don't need a conversion. In this case we just forward
    // the job id to the target page
    if (!hasConversion) {
        window.location = pageConfig.autoStart.target + '#j=' + uploader.getJob().getId();

        return;
    }

    var file = uploader.getInput(localId);
    var fileName = file.getName();
    var extension = fileName.substr(fileName.lastIndexOf('.') + 1);

    var hasConversionMap = pageConfig.autoStart.hasOwnProperty('conversionMap');
    var hasExtension = false;

    try {
        hasExtension = pageConfig.autoStart.conversionMap.hasOwnProperty(extension);
    } catch (e) {}

    if (hasConversionMap && hasExtension) {
        qgFeaturePage.startWithConversion(pageConfig.autoStart.conversionMap[extension], pageConfig.autoStart.target);

        return;
    }

    if (pageConfig.autoStart.useConversionFromForm === true) {
        let conversionFromForm = conversionOptions.getConversionOptionsFromForm('#sendform', uploader);

        qgFeaturePage.startWithConversion(conversionFromForm, pageConfig.autoStart.target);

        return;
    }

    qgFeaturePage.startWithConversion(pageConfig.autoStart.conversion, pageConfig.autoStart.target);
}

function handleTextInput(input) {
    const target = $('[name=target]').val();
    const category = $('[name=category]').val();
    const filename = 'hash.' + target;
    featureHelper.disableSubmit();

    const operation = window.pageConfig.operation;

    if (testIsNonEmptyString(input)) {
        input = btoa(unescape(encodeURIComponent(input)));
        uploadBase64String(input, target, category, filename, operation);
    }
}

/**
 * @param {String} base64
 * @param {String} target
 * @param {String} category
 * @param {String} filename
 * @param {String} [operation]
 */
function uploadBase64String(base64, target, category, filename, operation) {
    if (testIsUndefined(operation)) {
        operation = 'create system base64 string';
    }

    api.createJob({ operation: operation }).done(function (job) {
        var data = {
            content: base64,
            filename: filename,
        };

        var ajaxWrapper = new AjaxWrapper();
        var jobInfoHelper = new JobInfoHelper(job);

        var options = {
            url: jobInfoHelper.getUploadUrlBase64(),
            crossDomain: true,
            xhrFields: {
                withCredentials: false,
            },
            cache: false,
            headers: {
                'X-Oc-Token': jobInfoHelper.getToken(),
            },
            data: data,
            maxRetries: 1,
            timeout: 30000,
        };

        if (!conversionOptions.isConversionOptionsFormValid('#sendform')) {
            featureHelper.enableSubmit();
            return;
        }

        var data = conversionOptions.getConversionOptionsFromForm('#sendform', uploader);

        ajaxWrapper
            .postJson(options)
            .done(function () {
                api.addConversionWithCheck(job.id, data)
                    .done(function (data) {
                        window.location = satGlobals.getResultUrl() + '#j=' + job.id;
                    })
                    .fail(function () {
                        featureHelper.enableSubmit();
                    });
            })
            .fail(() => {
                featureHelper.enableSubmit();
            });
    });
}

class SelectHelper {
    /**
     * @param {JQuery} $select
     */
    constructor($select) {
        this.$select = $select;
    }

    isVisible() {
        return this.$select.is(':visible');
    }

    /**
     * @return {JQuery}
     */
    getOptGroups() {
        return this.$select.find('optgroup');
    }

    /**
     * @param {String} target
     *
     * @return {JQuery}
     */
    getOptGroupByTarget(target) {
        return this.$select.find('optgroup[data-options-target="' + target + '"]');
    }

    /**
     * @param {String} target
     *
     * @return {Boolean}
     */
    hasOptGroupbyTarget(target) {
        const $group = this.getOptGroupByTarget(target);

        return $group.length > 0;
    }

    /**
     * @return {number}
     */
    getNumberOfVisibleOptGroups() {
        let numberOfVisible = 0;

        const $groups = this.getOptGroups();

        $groups.each(function (idx) {
            const $el = $(this);

            if (!$el.hasClass('hidden')) {
                numberOfVisible++;
            }
        });

        return numberOfVisible;
    }

    getSelectedTargetFromSelect() {
        const $groups = this.getOptGroups();

        let target = '';

        $groups.each(function (idx) {
            const $el = $(this);

            if (!$el.hasClass('hidden')) {
                target = $el.data('options-target');
            }
        });

        return target;
    }
}

global.qgFeaturePage = {
    /**
     *
     * @param {object} config
     * @param {object}   pageConfig
     * @param {boolean}  pageConfig.useDefaultButtons
     * @param {boolean}  pageConfig.singleFile
     * @param {function} pageConfig.submitFunction
     * @param {String}   pageConfig.target
     * @param {String}   pageConfig.operation
     * @param {String}   pageConfig.example_file
     *
     * @return {Uploader}
     */
    async init(config, pageConfig) {
        if (global.MODULE_LOADED_UPLOADER_FUNCTIONS) {
            globalLogger.log('double import feature page init');

            return uploader;
        }

        global.MODULE_LOADED_UPLOADER_FUNCTIONS = true;

        try {
            let operation = 'unknown';

            if (testIsNonEmptyString(pageConfig.operation)) {
                operation = pageConfig.operation;
            }

            if (testIsNonEmptyString(window.qgOperation)) {
                operation = window.qgOperation;
            }

            globalLogger.addLogData('operation', operation);
        } catch (e) {}

        // var paymentRequiredCallback = function (e) {
        //     try {
        //         // this is the generic payment-required callback which does not really know _why_ a
        //         // payment required code was sent. it is just meant as backup if the other callback
        //         // is not triggered (check globalEventCallbackLimits)
        //         // since this callback is triggered before the other callbacks we have to delay it for a
        //         // tiny bit so that the payment overlay is called with the correct event (which then results in
        //         // a correct error message)
        //         setTimeout(function () {
        //             limitReached();
        //         }, 2000);
        //     } catch (e) {}
        // };

        if (pageConfig.hasOwnProperty('captchaKey')) {
            captchaKey = pageConfig.captchaKey;
        }

        var apiConfig = new ApiConfig(config);

        // apiConfig.paymentRequiredCallback = paymentRequiredCallback;

        uploader = createGlobalUploader(config, apiConfig);

        api = uploader.getApiHelper();

        await createSatUi(uploader, config);

        window.qgUploader = uploader;

        // by default we always use the standard buttons. This can be disabled by setting
        // pageConfig.useDefaultButtons to false
        if (pageConfig.useDefaultButtons !== false) {
            featureHelper.setupUploadButtons(uploader);
        }

        // If you need something special to happen when the user presses the default submit
        // button then you can use pageConfig.submitFunction
        if (pageConfig.hasOwnProperty('submitFunction')) {
            assertIsFunction(pageConfig.submitFunction);
            $(document).on('click', '.submit-btn', pageConfig.submitFunction);
        } else if (pageConfig.uploaderMode === 'aigeneration') {
            const submitBtns = document.getElementsByClassName('submit-btn');
            for (const submitBtn of submitBtns) {
                submitBtn.addEventListener('click', () => {
                    featureHelper.disableSubmit();
                    handleAIGenerationSubmit();
                });
            }
        } else if (pageConfig.uploaderMode === 'aisimilarcreation') {
            const submitBtns = document.getElementsByClassName('submit-btn');
            for (const submitBtn of submitBtns) {
                submitBtn.addEventListener('click', () => {
                    featureHelper.disableSubmit();
                    handleAISimilarCreationSubmit();
                });
            }
        } else {
            if (!pageConfig.hasOwnProperty('submitOnDemand')) {
                $(document).on('click', '.submit-btn', featureHelper.defaultSubmitFunction);
            }
        }

        const stopBtns = document.getElementsByClassName('stop-btn');
        if (stopBtns.length) {
            for (const stopBtn of stopBtns) {
                stopBtn.addEventListener('click', () => {
                    eventBus.emit(STOP_AUTO_START_UPLOAD);
                    featureHelper.enableSubmit();
                });
            }
        }

        /**
         * @param {string} event
         * @param {number} localId
         * @param data2
         */
        var inputEventCallbackMain = function (event, localId, data2) {
            // allow user to leave page if there are no inputs
            window.allowLeave = uploader.isEmpty();
            const input = uploader.getInput(localId);

            if (event === INPUT_EVENT_DONE && input.getType() === INPUT_TYPE_EXTERNAL_URL) {
                const contentType = input.getContentType();
                const engine = input.getEngine();

                if (contentType === 'text/html' && engine === 'auto') {
                    engineHelper.add(localId);
                }
            }

            // If the conversion should auto start when one file is added
            if (pageConfig.hasOwnProperty('autoStart')) {
                handleAutoStart(pageConfig, event, localId);
            }
        };

        /**
         * @param {string} event
         * @param {number} localId
         */
        function inputEventCallbackInitialExtensionAsTargetCallback(event, localId) {
            if (!pageConfig.hasOwnProperty('initialExtensionAsTarget')) {
                return;
            }

            var inputs = uploader.getInputList();

            if (inputs.getNumberOfInputsInApi() > 1) {
                return;
            }

            let input = uploader.getInput(localId);
            let extension = input.getName().split('.').pop().toLowerCase();

            if (
                event === INPUT_EVENT_SUBMITTING ||
                event === INPUT_EVENT_LOADING ||
                (event === INPUT_EVENT_DONE && extension === 'png')
            ) {
                // NOTE:
                // this will explode if the user enters a url like this: "www.test.de"
                // then the extension will be: de"
                // and jQuery will generate a Syntax error. But this is ok because we only care
                // about the valid extensions ".png" and ".jpg"
                try {
                    if ($('#inputTarget option[value=' + extension + ']').length > 0) {
                        $('#inputTarget').val(extension).change();

                        let category = $('#inputTarget').find(':selected').data('category');
                        conversionOptions.showRelevantOptionsForTarget(category, extension, uploader);
                    }
                } catch (e) {
                    // do nothing because we care only about .jpg and .png extensions
                }
            }
        }

        var jobCreationFailed = false;

        /**
         * @param {string} event
         */
        function globalEventCallbackLimits(event) {
            // when job create failed we want to show a message to the user
            if (event === GLOBAL_EVENT_JOB_CREATE_FAIL) {
                jobCreationFailed = true;

                var message = translate('Sorry, something went wrong. Please try again, or refresh the page.');

                pageNotification.warning(message);

                return;
            }

            // if there was a problem with job creation then we want to sent a log about it.
            if (event === GLOBAL_EVENT_JOB_CREATE_DONE && jobCreationFailed) {
                globalLogger.log('qgApiHelper createJob info - done after fail');

                return;
            }
        }

        eventBus.listen(UPLOADER_EVENT, (uploaderEvent) => {
            /** @type {UploaderEvent} */
            const _uploaderEvent = uploaderEvent;

            assertIsUploaderEvent(_uploaderEvent);

            if (testIsInputEvent(_uploaderEvent.event)) {
                inputEventCallbackMain(_uploaderEvent.event, _uploaderEvent.localId, _uploaderEvent.data);

                inputEventCallbackInitialExtensionAsTargetCallback(_uploaderEvent.event, _uploaderEvent.localId);
            }

            if (testIsGlobalEvent(_uploaderEvent.event)) {
                globalEventCallbackLimits(_uploaderEvent.event);
            }
        });

        $('.ocr_mode_selection').hide();
        $('.ocr_monochrome_selection').hide();

        //Hide layout dropdown on default, because else both are shown
        $('#convert_language optgroup[id="focus_text"]').show();
        $('#convert_language optgroup[id="focus_layout"]').hide();

        var showOcrMode = function () {
            var selectedOcrMode = $('#ocr_mode').find('option:selected').val().toLocaleLowerCase().trim();
            $('#convert_language option[value="null"]').prop('selected', true);

            if (selectedOcrMode === 'layout') {
                $('#convert_language optgroup[id="focus_text"]').hide();
                $('#convert_language optgroup[id="focus_layout"]').show();
                $('.ocr_monochrome_selection').show();
            } else if (selectedOcrMode === 'text') {
                $('#convert_language optgroup[id="focus_layout"]').hide();
                $('#convert_language optgroup[id="focus_text"]').show();
                $('.ocr_monochrome_selection').hide();
                globalLogger.log('modConversion unknown option', { info: JSON.stringify(conversionOptions) });
            }
        };

        $('#ocr_mode').on('change', function () {
            showOcrMode();
            var ocr_monochrome = $('input[name="ocr_monochrome"]');
            if ($('#ocr_mode').find('option:selected').val().toLocaleLowerCase().trim() === 'text') {
                ocr_monochrome.data('option-ignore', true);
                ocr_monochrome.attr('data-option-ignore', true);
            } else {
                ocr_monochrome.data('option-ignore', false);
                ocr_monochrome.attr('data-option-ignore', false);
            }
        });

        const widthPercentageElement = document.getElementsByClassName('input-width-percentage')[0];
        const heightPercentageElement = document.getElementsByClassName('input-height-percentage')[0];
        const startResolutionElement = document.getElementById('startResolution');
        const endResolutionElement = document.getElementById('endResolution');
        const outputResolutionWrapper = document.getElementById('outputResolutionWrapper');
        let percentageHeight = 0;
        let percentageWidth = 0;

        if (widthPercentageElement && heightPercentageElement) {
            widthPercentageElement.addEventListener('input', () => {
                const input = getInputForResolutionInfo();
                if (input !== null) {
                    percentageWidth = parseInt(widthPercentageElement.value);
                    setResolutionInfo(input);
                }
            });

            heightPercentageElement.addEventListener('input', () => {
                const input = getInputForResolutionInfo();
                if (input !== null) {
                    percentageHeight = parseInt(heightPercentageElement.value);
                    setResolutionInfo(input);
                }
            });
        }

        function getInputForResolutionInfo() {
            const inputs = uploader.getInputList();
            if (inputs.getNumberOfAllInputs() === 1) {
                const input = inputs.getInput(0);
                if (input.getType() === INPUT_TYPE_FILE_UPLOAD && input.getStatus() === INPUT_STATUS_UPLOADER_DONE) {
                    return input;
                }
            }

            return null;
        }

        function setResolutionInfo(input) {
            const startWidth = input.getMetadata()?.image_width;
            const startHeight = input.getMetadata()?.image_height;
            let widthOfOutput = 0;
            let heightOfOutput = 0;

            if (percentageWidth !== 0 && (percentageHeight === 0 || Number.isNaN(percentageHeight))) {
                widthOfOutput = parseInt((startWidth * percentageWidth) / 100);
                heightOfOutput = parseInt((startHeight * percentageWidth) / 100);
            } else if (percentageHeight !== 0 && (percentageWidth === 0 || Number.isNaN(percentageWidth))) {
                widthOfOutput = parseInt((startWidth * percentageHeight) / 100);
                heightOfOutput = parseInt((startHeight * percentageHeight) / 100);
            } else {
                widthOfOutput = parseInt((startWidth * percentageWidth) / 100);
                heightOfOutput = parseInt((startHeight * percentageHeight) / 100);
            }

            outputResolutionWrapper.classList.remove('hidden');
            startResolutionElement.innerText = `${startWidth}x${startHeight}`;
            endResolutionElement.innerText = `${widthOfOutput}x${heightOfOutput}`;
        }

        function updateInputRange() {
            const slider = document.getElementById('inputRange');
            const rangeInputValue = document.getElementById('inputRangeValue');
            const inputContainer = document.getElementById('scalePercContainer');

            const width = document.querySelector('.input-width-percentage');
            const height = document.querySelector('.input-height-percentage');

            const hint = document.querySelector('.ai-upscale-resize-hint');
            const resizeInput = document.querySelector('[name=resize_handling]');

            if (slider) {
                inputContainer.addEventListener('click', () => {
                    width.value = slider.value;
                    height.value = slider.value;

                    resizeInput.value="";
                });

                rangeInputValue.addEventListener('input', () => {
                    const value = parseInt(rangeInputValue.value, 10);
                
                    slider.value = value;
                    width.value = value;
                    height.value = value;
                
                    hint?.classList?.toggle('d-none', value <= 100);
                    hint?.classList?.toggle('d-flex', value > 100);

                    resizeInput.value="";
                });
                
                slider.addEventListener('input', () => {
                    rangeInputValue.value = slider.value;
                    width.value = slider.value;
                    height.value = slider.value;
                
                    hint?.classList?.toggle('d-none', slider.value <= 100);
                    hint?.classList?.toggle('d-flex', slider.value > 100);

                    resizeInput.value="";
                });
            }
        }

        function updateDeviceBoxes() {
            const deviceWidth = document.querySelector('.input-width-device');
            const deviceBoxes = document.querySelectorAll('.device-box');

            if (deviceBoxes) {
                deviceBoxes.forEach((box) => {
                    box.addEventListener('click', () => {
                        const selectedValue = box.dataset.value;
                        const previousSelected = document.querySelector('.device-box.selected');

                        if (previousSelected) {
                            previousSelected.classList.remove('selected');
                        }

                        deviceWidth.value = selectedValue;
                        box.classList.add('selected');
                    });
                });
            }
        }

        function updateAspectRatio() {
            const aspectRatioBoxes = document.querySelectorAll('.aspect-ratio-box');

            if (aspectRatioBoxes) {
                aspectRatioBoxes.forEach((box) => {
                    box.addEventListener('click', () => {
                        const selectedValue = box.dataset.value;
                        const aspectRatio = document.querySelector('#aspectRatio');

                        const previousSelected = document.querySelector('.aspect-ratio-box.selected');
                        if (previousSelected) {
                            previousSelected.classList.remove('selected');
                        }

                        aspectRatio.value = selectedValue;
                        box.classList.add('selected');
                    });
                });
            }
        }

        function updateResizeHandlingBoxes(value, section) {
            const resizeInput = document.querySelector('[name=resize_handling]');
            let resizeBoxes = document.querySelectorAll('.resize-box-border');

            if (value) {
                resizeBoxes = document.querySelectorAll(`${section} .resize-box-border`);
                const previousSelected = document.querySelectorAll(`${section} .resize-box-border.selected`);
                
                if (previousSelected.length === 0) {
                    resizeInput.value = value;
                    resizeBoxes[0].classList.add('selected');
                }
            }

            if (resizeBoxes) {
                resizeBoxes.forEach((box) => {
                    box.addEventListener('click', () => {
                        const selectedValue = box.dataset.value;                        
                        const previousSelected = document.querySelectorAll('.resize-box-border.selected');

                        previousSelected.forEach((previousBox) => {
                            previousBox.classList.remove('selected');
                        });

                        resizeInput.value = selectedValue;
                        box.classList.add('selected');
                    });
                });
            }
        }

        function updateSocialPreset() {
            const socialBoxes = document.querySelectorAll('.social-box');

            const widthInput = document.querySelector('.input-width-social');
            const heightInput = document.querySelector('.input-height-social');

            if (socialBoxes.length) {
                socialBoxes.forEach((box) => {
                    box.addEventListener('click', () => {
                        const selectedWidth = box.dataset.width;
                        const selectedHeight = box.dataset.height;

                        const previousSelected = document.querySelector('.social-box.selected');
                        if (previousSelected) {
                            previousSelected.classList.remove('selected');
                        }

                        widthInput.value = selectedWidth;
                        heightInput.value = selectedHeight;

                        box.classList.add('selected');
                    });
                });
            }
        }

        function toggleResizeHandlingSections(sectionToShow) {
            const sections = {
                'scale-dimension': '#dimensionResizeHandling',
                'scale-ratio': '#aspectResizeHandling',
                'scale-social': '#socialResizeHandling'
            };

            Object.values(sections).forEach(selector => {
                document.querySelector(selector)?.classList.add('d-none');
                document.querySelector(selector)?.classList.remove('d-flex');
            });

            const currentSection = document.querySelector(sections[sectionToShow]);
            
            currentSection?.classList.add('d-flex');
            currentSection?.classList.remove('d-none');

            if (sectionToShow === 'scale-dimension') {
                updateResizeHandlingBoxes('stretch', '#dimensionResizeHandling');
            }
            if (sectionToShow === 'scale-ratio') {
                updateResizeHandlingBoxes('keep_aspect_ratio_crop', '#aspectResizeHandling');
            }
            if (sectionToShow === 'scale-social') {
                updateResizeHandlingBoxes('keep_aspect_ratio_fill_blurred', '#socialResizeHandling');
            }
            
        }

        var inputTarget = $('#inputTarget');

        $(document).ready(function () {
            $('.radio-toggle').on('click', function (event) {
                if ($(this).find('.aspect-ratio-box').length === 0) {
                    $('.aspect-ratio-box').removeClass('selected');
                }

                if ($(this).find('.aspect-ratio-box.selected').length === 0) {
                    var $firstElement = $(this).find('.aspect-ratio-box').first();
                    if ($firstElement.length) {
                        $firstElement.addClass('selected');
                        $('#aspectRatio').val('1:1');
                    }
                }

                if ($(this).find('.social-box').length === 0) {
                    $('.social-box').removeClass('selected');
                }

                if ($(this).find('.social-box.selected').length === 0) {
                    const $socialFirstElement = $(this).find('.social-box').first();
                    if ($socialFirstElement.length) {
                        $socialFirstElement.addClass('selected');
                    }
                }

                if ($(this).find('.device-box').length === 0) {
                    $('.device-box').removeClass('selected');
                }

                if ($(this).find('.device-box.selected').length === 0) {
                    const $deviceFirstElement = $(this).find('.device-box').first();
                    const resizeInput = document.querySelector('[name=resize_handling]');

                    if ($deviceFirstElement.length) {
                        $deviceFirstElement.addClass('selected');
                        resizeInput.value="";
                    }
                }

                const dataName = $(this).attr('name');
                if (dataName) {
                    toggleResizeHandlingSections(dataName);
                }
            });

            var inputTargetFromElement = inputTarget.find('option:selected').val();
            if (inputTargetFromElement === undefined) {
                var target = pageConfig.target;
                updateDropdownsForTarget(target);
            } else {
                updateDropdownsForTarget(inputTargetFromElement);
            }

            $('#page_size_unit').on('change', function () {
                var unit = $('#page_size_unit').val();
                var customPageSizeHeight = $('#inputCustomPageHeight');
                var customPageSizeWidth = $('#inputCustomPageWidth');
                var customPageSizeUnit = $('.custom-page-size-unit');
                customPageSizeUnit.html(unit);
                if (unit === 'in') {
                    customPageSizeHeight.attr('max', 11650);
                    customPageSizeWidth.attr('max', 11650);
                }

                if (unit === 'mm') {
                    customPageSizeHeight.attr('max', 295931);
                    customPageSizeWidth.attr('max', 295931);
                }
                customPageSizeWidth.attr(
                    'placeholder',
                    customPageSizeWidth.attr('min') + ' - ' + customPageSizeWidth.attr('max')
                );
                customPageSizeHeight.attr(
                    'placeholder',
                    customPageSizeHeight.attr('min') + ' - ' + customPageSizeHeight.attr('max')
                );
            });

            if (isMobile()) {
                scrollSubmitButtonIntoView();
            }

            hideImageScaleIfRemoteInput();

            function updateResizeHandling() {
                var resizeMethod = $('#resize_handling').val();
                var keepAspectRatio = $('#keep_aspect_ratio').is(':checked');

                if (resizeMethod === 'keep_aspect_ratio_fill' || keepAspectRatio) {
                    $('#resize_handling').data('option-ignore', true);
                    $('#resize_handling_fill').data('option-ignore', false);
                    $('.resize-handling-container').removeClass('hidden');
                } else {
                    $('#resize_handling').data('option-ignore', false);
                    $('#resize_handling_fill').data('option-ignore', true);
                    $('.resize-handling-container').addClass('hidden');
                }

                if (resizeMethod === 'keep_aspect_ratio_fill' && $('#resize_handling_fill').val() === null) {
                    $('#resize_handling_fill').val('keep_aspect_ratio_fill_black');
                }
            }

            updateResizeHandling();
            setupNormalizeAudio();

            function setupNormalizeAudio() {
                if (pageConfig.operation === 'normalizeaudio') {
                    $('#normalizeType option[data-value="none"]').remove();

                    $('.ebu-option').addClass('d-none');
                    $('.rms-peak').addClass('d-none');
                    $('#automaticNormalize').prop('checked', true);
                }
            }

            $('#normalizeType').on('change', function () {
                const normalizeOption = $('#normalizeType').val();
                const dataOption = $('#normalizeType').data('value');

                if (dataOption === 'none') {
                    $('#automaticNormalize').prop('checked', false);
                    $('.rms-peak').addClass('d-none');
                    $('.ebu-option').addClass('d-none');
                } else {
                    if (dataOption === 'auto') {
                        $('.ebu-option').addClass('d-none');
                        $('.rms-peak').addClass('d-none');
                        $('#automaticNormalize').prop('checked', true);
                    } else if (normalizeOption === 'ebu') {
                        $('.ebu-option').removeClass('d-none');
                        $('.rms-peak').addClass('d-none');
                        $('#automaticNormalize').prop('checked', true);
                    } else if (normalizeOption === 'rms' || normalizeOption === 'peak') {
                        $('.ebu-option').addClass('d-none');
                        $('.rms-peak').removeClass('d-none');
                        $('#automaticNormalize').prop('checked', true);
                    } else {
                        $('.ebu-option').addClass('d-none');
                        $('.rms-peak').addClass('d-none');
                        $('#automaticNormalize').prop('checked', true);
                    }
                }
            });

            $('#resize_handling').on('change', function () {
                updateResizeHandling();
            });

            $('#keep_aspect_ratio').on('change', function () {
                updateResizeHandling();
            });

            $('[name=audio_codec]').on('change', () => {
                let selectedAudioCodec = $('[name=audio_codec]').val();
                if (selectedAudioCodec === 'vorbis') {
                    $('[name=audio_bitrate] optgroup[data-options-target="default"]').addClass('hidden');
                    $('[name=audio_bitrate] optgroup').addClass('hidden');
                    $('[name=audio_bitrate] optgroup[data-options-target="vorbis"]')
                        .removeClass('hidden')
                        .prop('disabled', false);
                }
                if (selectedAudioCodec === 'mp3') {
                    const mp3AudioFrequencyOptGroup = $('[name=audio_frequency] optgroup[data-options-target="mp3"]');
                    const mp3AudioBitrateOptGroup = $('[name=audio_bitrate] optgroup[data-options-target="mp3"]');

                    if (mp3AudioFrequencyOptGroup.length > 0) {
                        $('[name=audio_frequency] optgroup[data-options-target="default"]').addClass('hidden');
                        $('[name=audio_frequency] optgroup').addClass('hidden');
                        mp3AudioFrequencyOptGroup.removeClass('hidden').prop('disabled', false);
                    }

                    $('[name=audio_bitrate] optgroup[data-options-target="default"]').addClass('hidden');
                    $('[name=audio_bitrate] optgroup').addClass('hidden');
                    mp3AudioBitrateOptGroup.removeClass('hidden').prop('disabled', false);
                }
            });

            $('#resize_unit').on('change', () => {
                let $widthUnitElement = $('.input-settings-width .input-group-addon');
                let $heightUnitElement = $('.input-settings-height .input-group-addon');
                let $inputWidth = $('#inputWidth');
                let $inputHeight = $('#inputHeight');
                let resizeUnit = $('#resize_unit').val();

                $widthUnitElement.html('px');
                $heightUnitElement.html('px');
                $inputWidth.attr('max', '65000');
                $inputWidth.data('value-type', 'int');
                $inputHeight.data('value-type', 'int');
                $inputHeight.attr('max', '65000');

                if (resizeUnit === 'perc') {
                    $widthUnitElement.html('%');
                    $heightUnitElement.html('%');
                    $inputWidth.attr('max', '99');
                    $inputHeight.attr('max', '99');
                    $inputWidth.data('value-type', 'float');
                    $inputHeight.data('value-type', 'float');
                }

                updatePlaceholders();
            });

            $('#resolution_unit').on('change', () => {
                let $inputWidth = $('#inputWidth');
                let $inputHeight = $('#inputHeight');
                let resolutionUnit = $('#resolution_unit').val();

                if (resolutionUnit === 'mm') {
                    $inputWidth.attr('max', '20000');
                    $inputHeight.attr('max', '20000');
                } else if (resolutionUnit === 'cm') {
                    $inputWidth.attr('max', '2000');
                    $inputHeight.attr('max', '2000');
                } else if (resolutionUnit === 'inches') {
                    $inputWidth.attr('max', '1000');
                    $inputHeight.attr('max', '1000');
                } else {
                    // resolutionUnit === px
                    $inputWidth.attr('max', '200000');
                    $inputHeight.attr('max', '200000');
                }

                updatePlaceholders();
            });

            // Resize options
            updateInputRange();
            updateDeviceBoxes();
            updateAspectRatio();
            updateResizeHandlingBoxes();
            updateSocialPreset();

            setConversionOptionsFromGetParameters();
        });

        var selects = {
            reader: $('select[name="reader"]'),
            audio_codec: $('select[name="audio_codec"]'),
            frequency: $('select[name="frequency"]'),
            audio_bitrate: $('select[name="audio_bitrate"]'),
            audio_vbr: $('select[name="audio_vbr"]'),
            codec: $('select[name="codec"]'),
            rounds: $('select[name="rounds"]'),
            preset: $('select[name="preset"]'),
            audio_frequency: $('select[name="audio_frequency"]'),
        };

        inputTarget.on('change', function () {
            var selectedTargetFormat = $(this).find('option:selected').val().toLocaleLowerCase().trim();

            if (selectedTargetFormat === 'png') {
                $('#compress_none').parent().removeClass('col-1');
                $('.quality-panel').addClass('pl-35');
                $('.quality-panel').removeClass('pl-20');
                $('.quality-panel').click();
            } else {
                $('#compress_none').parent().addClass('col-1');
                $('.quality-panel').addClass('pl-20');
                $('.quality-panel').removeClass('pl-35');
            }

            var targetsWithOcrMode = ['docx', 'doc'];
            if (targetsWithOcrMode.indexOf(selectedTargetFormat) === -1) {
                $('#convert_language optgroup[id="focus_text"]').show();
                $('#convert_language optgroup[id="focus_layout"]').hide();
            } else {
                $('#convert_language optgroup[id="focus_text"]').hide();
                $('#convert_language optgroup[id="focus_layout"]').show();
            }

            updateDropdownsForTarget(selectedTargetFormat);
        });

        function updateDropdownsForTarget(selectedTargetFormat) {
            for (var select in selects) {
                /** @type {JQuery} */
                const $select = selects[select];

                // if the select does not appear on the page then we ignore it
                if ($select.length === 0) {
                    continue;
                }

                const $allOptGroups = $select.find('optgroup');

                // hide all optgroups
                $allOptGroups.addClass('hidden');
                $allOptGroups.prop('disabled', true);

                function showOptGroup(selectorDefault, selectorTarget) {
                    const $optGroupDefault = $select.find(selectorDefault);
                    const $optGroupTarget = $select.find(selectorTarget);

                    let $optGroup = $optGroupDefault;

                    // if there is a specific optgroup for the selected target then we use that one instead of the default group
                    if ($optGroupTarget.length > 0) {
                        $optGroup = $optGroupTarget;
                    }

                    if ($optGroup.length === 0) {
                        return;
                    }

                    // unhide the optgroup
                    $optGroup.removeClass('hidden');
                    $optGroup.prop('disabled', false);

                    const defaultValue = $optGroup.data('options-default-value');

                    //get currently selected option
                    const selectedOption = $optGroup.find(':selected');

                    let selectedSelector;

                    // if no default option is set then just take the first one
                    if (testIsUndefined(defaultValue)) {
                        // select the first entry in the opt group
                        selectedSelector = 'option:first';
                    } else {
                        selectedSelector = 'option[value="' + defaultValue + '"]';
                    }

                    const selected = $optGroup.find(selectedSelector);

                    // If the currently selected option does not match the default option
                    // or is not part of the visible optgroup, reset the selection
                    if (selected.val() !== selectedOption.val() || selectedOption.closest('optgroup').hasClass('hidden')) {
                        selectedOption.prop('selected', false);
                        selected.prop('selected', true);
                    }

                    if (selected.length === 0) {
                        globalLogger.log('select checker - could not find default value', defaultValue);
                    }

                    const $allOptions = $optGroup.find('option');

                    $allOptions.prop('selected', false);

                    selected.prop('selected', true);
                }

                const modernDefaultSelector = 'optgroup[data-options-target="default"]';
                const modernTargetSeletor = 'optgroup[data-options-target="' + selectedTargetFormat + '"]';

                showOptGroup(modernDefaultSelector, modernTargetSeletor);

                // this is the old way in which the data was stored. it is only here for backwards compatibility
                const oldTargetSeletor = 'optgroup[id="' + selectedTargetFormat + '"]';
                const oldDefaultSelector = 'optgroup[id="default"]';

                showOptGroup(oldDefaultSelector, oldTargetSeletor);
            }
        }

        //Check if uploaded file is a remote file -> hide scale option, because we can't get metadata of remotely uploaded files
        function hideImageScaleIfRemoteInput() {
            var interval = setInterval(function () {
                if (uploader.isReadyToSubmit() && uploader.getInput(0).getType() === INPUT_TYPE_EXTERNAL_URL) {
                    $('#image_scale').addClass('hidden');
                    $('#image_scale').parent().addClass('hidden');
                    clearInterval(interval);
                }
            }, 250);
        }

        eventBus.listen(VUE_NO_UPLOADER_START_CLICK, doNoUploadSubmit);

        function doNoUploadSubmit() {
            var format = $('#page_size_selector').val();
            var orientation = $('#page_orientation').val();

            var width = pageSizes[format].width;
            var height = pageSizes[format].height;

            if (orientation === 'landscape') {
                width = pageSizes[format].height;
                height = pageSizes[format].width;
            }

            //TODO implement custom page size in cm/mm/inches
            // if ($('#custom_page_size').is(':checked')) {
            //     var width = parseInt($('#inputCustomPageWidth').val());
            //     var height = parseInt($('#inputCustomPageHeight').val());
            // }

            createPageWithResolution(width, height);
        }

        $('.no-upload-submit-btn').on('click', function () {
            $('.no-upload-submit-btn').find('i').removeClass('fa-arrow-right').addClass('fa-spinner fa-spin');

            doNoUploadSubmit();
        });

        $('.add-example-file').on('click', function () {
            uploader.addExternalUrl(pageConfig.example_file);
            if (isPremiumFeature()) {
                $('.submit-btn').prop('disabled', false);
                //This is to prevent the user from uploading files other than the example file on premium features
                uploader.disable();
            }
        });

        // OC not convinced link
        $(document).on('click', '#not-convinced-link', (e) => {
            window.qgUploader.addExternalUrl(pageConfig.example_file);
        });

        function isPremiumFeature() {
            const uploaderStore = useUploaderStore();
            const uploaderLimit = uploaderStore.getDisplayLimitError;

            return uploaderLimit?.name === LIMIT_FEATURE_IS_PREMIUM;
        }

        function createPageWithResolution(width, height) {
            api.createJob({ operation: 'create system thumbnail' }).done(function (job) {
                const base64svg =
                    'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNTk1cHgiIGhlaWdodD0iODQycHgiIHZpZXdCb3g9IjAgMCA2MTIgNzkyIiB2ZXJzaW9uPSIxLjEiPgo8ZyBpZD0ic3VyZmFjZTEiPgo8L2c+Cjwvc3ZnPgo=';
                var data = {
                    content: base64svg,
                    filename: 'source.svg',
                };

                var ajaxWrapper = new AjaxWrapper();
                var jobInfoHelper = new JobInfoHelper(job);

                var options = {
                    url: jobInfoHelper.getUploadUrlBase64(),
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: false,
                    },
                    cache: false,
                    headers: {
                        'X-Oc-Token': jobInfoHelper.getToken(),
                    },
                    data: data,
                    maxRetries: 1,
                    // this is set to 30 seconds so we automatically fall back to old method for large uploads
                    // in the fallback the user sees upload progress
                    timeout: 30000,
                };

                ajaxWrapper.postJson(options).done(function () {
                    api.addConversionWithCheck(job.id, {
                        target: 'png',
                        category: 'image',
                        options: {
                            width: width,
                            height: height,
                            dpi: 120,
                            allow_multiple_outputs: true,
                        },
                    })
                        .done(function (data) {
                            window.location = pageConfig.noUpload.target + '/#j=' + job.id;
                        })
                        .fail(function () {});
                });
            });
        }
        const uploaderCreditDisplay = document.getElementById('uploader-credit-display');
        if (uploaderCreditDisplay) {
            createApp(UploaderCreditDisplay).mount('#uploader-credit-display');
        }

        const surpriseMeBtn = document.getElementById('surprise-me-btn');
        if (surpriseMeBtn) {
            surpriseMeBtn.addEventListener('click', () => {
                const randomPrompt = SURPRISE_ME_PROMPTS[Math.floor(Math.random() * SURPRISE_ME_PROMPTS.length)];

                document.getElementById('inputPrompt').value = randomPrompt;
                document.getElementById('text-area-label').classList.add('vuetiful-label-small');
            });
        }

        async function handleAIGenerationSubmit() {
            const user = await userManager.getUser();
            let prompt = document.getElementById('inputPrompt').value;
            const negativePrompt = document.getElementById('inputNegativePrompt').value;

            if (prompt === '') {
                document.getElementById('inputPrompt').value = DEFAULT_PROMPT;
                document.getElementById('text-area-label').classList.add('vuetiful-label-small');
                prompt = DEFAULT_PROMPT;
            }

            api.createJob({ operation: pageConfig.operation })
                .done((job) => {
                    const base64Prompt = bytesToBase64(new TextEncoder().encode(prompt));
                    const base64NegativePrompt = bytesToBase64(new TextEncoder().encode(negativePrompt));

                    var dataPositive = {
                        content: 'data:text/plain;base64,' + base64Prompt,
                        filename: 'prompt.txt',
                        options: {
                            type: 'prompt',
                        },
                    };

                    var dataNegative = {
                        content: 'data:text/plain;base64,' + base64NegativePrompt,
                        filename: 'negative_prompt.txt',
                        options: {
                            type: 'negative_prompt',
                        },
                    };

                    const ajaxWrapper = new AjaxWrapper();
                    const jobInfoHelper = new JobInfoHelper(job);

                    const optionsPositive = {
                        url: jobInfoHelper.getUploadUrlBase64(),
                        crossDomain: true,
                        xhrFields: {
                            withCredentials: false,
                        },
                        cache: false,
                        headers: {
                            'X-Oc-Token': jobInfoHelper.getToken(),
                        },
                        data: dataPositive,
                        maxRetries: 1,
                        // this is set to 30 seconds so we automatically fall back to old method for large uploads
                        // in the fallback the user sees upload progress
                        timeout: 30000,
                    };

                    const optionsNegative = {
                        url: jobInfoHelper.getUploadUrlBase64(),
                        crossDomain: true,
                        xhrFields: {
                            withCredentials: false,
                        },
                        cache: false,
                        headers: {
                            'X-Oc-Token': jobInfoHelper.getToken(),
                        },
                        data: dataNegative,
                        maxRetries: 1,
                        // this is set to 30 seconds so we automatically fall back to old method for large uploads
                        // in the fallback the user sees upload progress
                        timeout: 30000,
                    };

                    const sizeMapping = {
                        '1:1': {
                            width: 1024,
                            height: 1024,
                        },
                        '4:5': {
                            width: 915,
                            height: 1144,
                        },
                        '3:2': {
                            width: 1254,
                            height: 836,
                        },
                        '4:3': {
                            width: 1182,
                            height: 886,
                        },
                        '9:16': {
                            width: 768,
                            height: 1334,
                        },
                        '21:9': {
                            width: 1564,
                            height: 670,
                        },
                        '16:9': {
                            width: 1365,
                            height: 768,
                        },
                    };

                    const aiStyle = document.getElementById('inputStyle').value;
                    const size = document.getElementById('inputSize').value;
                    let batchCount = 1;

                    if (user && (user.isPremium() || user.isEducational())) {
                        batchCount = 2;
                    }
                    const conversion = {
                        target: 'text-to-image',
                        category: 'operation',
                        options: {
                            width: sizeMapping[size].width,
                            height: sizeMapping[size].height,
                            style: aiStyle,
                            allow_multiple_outputs: true,
                            cfg_scale: 3,
                            num_inference_steps: 20,
                            batch_size: 2,
                            batch_count: batchCount,
                        },
                        sat: {
                            job_extra: {
                                prompt: prompt,
                                negative_prompt: negativePrompt,
                            },
                        },
                    };

                    ajaxWrapper
                        .postJson(optionsPositive)
                        .done(() => {
                            if (testIsNonEmptyString(negativePrompt)) {
                                ajaxWrapper
                                    .postJson(optionsNegative)
                                    .done(() => {
                                        api.addConversionWithCheck(job.id, conversion)
                                            .done(async function (response) {
                                                window.location = '/ai-creator-studio#j=' + job.id;
                                            })
                                            .fail(function (apiError) {
                                                handleAiGenerationError();
                                            });
                                    })
                                    .fail((error) => {
                                        handleAiGenerationError();
                                    });
                            } else {
                                api.addConversionWithCheck(job.id, conversion)
                                    .done(function (response) {
                                        window.location = '/ai-creator-studio#j=' + job.id;
                                    })
                                    .fail(function (apiError) {
                                        handleAiGenerationError();
                                    });
                            }
                        })
                        .fail((error) => {
                            handleAiGenerationError();
                        });
                })
                .fail((error, response) => {
                    if (error === API_ERROR_PAYMENT_REQUIRED) {
                        limitReachedStartConversion(response);
                    }

                    handleAiGenerationError();
                });
        }

        async function _getBase64Image(url) {
            return new Promise((resolve, reject) => {
                let uri = url;
                encodeImageToBase64(uri).then((base64String) => {
                    resolve(decodeBase64ToImageUrl(base64String));
                });
            });
        }

        async function handleAISimilarCreationSubmit() {
            if (uploader.isEmpty()) {
                featureHelper.enableSubmit();
                return;
            }

            if (!uploader.isReadyToSubmit()) {
                setTimeout(function () {
                    handleAISimilarCreationSubmit();
                }, 500);
                return;
            }

            try {
                const jobId = uploader.getJob().getId();
            
                if (jobId) {
                    window.allowLeave = true;
                    window.location = '/ai-creator-studio#j=' + jobId;
                }
            } catch (error) {
                pageNotification.showGenericErrorMessage();
            }
        }

        function handleAiGenerationError() {
            featureHelper.enableSubmit();
            pageNotification.showGenericErrorMessage();
        }

        function updatePlaceholders() {
            $('#inputWidth').attr('placeholder', $('#inputWidth').attr('min') + ' - ' + $('#inputWidth').attr('max'));
            $('#inputHeight').attr(
                'placeholder',
                $('#inputHeight').attr('min') + ' - ' + $('#inputHeight').attr('max')
            );
        }

        function scrollSubmitButtonIntoView() {
            var $buttons = $('.submit-btn');

            if ($buttons.length === 0) {
                return;
            }

            var $submitButton = $buttons.first();

            if (isElementWithinView($submitButton)) {
                return;
            }

            //Check if a file is uploading (at least one .file-name element is present) every 250ms
            var interval = setInterval(function () {
                if ($('.file-name').length > 0) {
                    $([document.documentElement, document.body]).animate(
                        {
                            scrollTop: $submitButton.offset().top - 50,
                        },
                        500
                    );

                    clearInterval(interval);
                }
            }, 250);
        }

        function setConversionOptionsFromGetParameters() {
            // read both query and fragment data
            const queryData = {
                ...qgQueryFragmentHelper.getCurrentQueryData(),
                ...qgQueryFragmentHelper.getCurrentFragmentData(),
            };
            let target = $('[name=target]').val();

            const targetSelect = document.querySelector('select[name="target"]');

            if (
                targetSelect !== null &&
                testIsNonEmptyString(queryData?.target) &&
                targetSelect.querySelector(`option[value="${queryData.target}"]`) !== null
            ) {
                targetSelect.querySelector('option[selected]').selected = null;

                target = queryData.target;
                targetSelect.value = target;

                targetSelect.querySelectorAll('option')[targetSelect.selectedIndex].selected = 'selected';
            }

            for (var key in queryData) {
                let $element = $('[name="' + key + '"]');
                if (typeof ocConversionOptionsMapping[key] !== 'undefined') {
                    $element = $('[name="' + ocConversionOptionsMapping[key] + '"]');
                }

                if ($element.length === 0) {
                    // option not found, skip
                    continue;
                }

                if (key === 'language') {
                    $('#inputLanguage').data('user-language', queryData[key]);
                }

                if (key === 'ocr' && testIsTrueish(queryData[key])) {
                    $('#ocr_enabled').attr('checked', true);
                }

                const elementType = $element.prop('nodeName');
                let value = queryData[key];
                if (elementType === 'SELECT') {
                    let $optgroup = $element.find('optgroup[data-options-target="' + target + '"]');

                    //if the optgroup for the specific target does not exist,
                    //use the default one
                    if ($optgroup.length === 0) {
                        $optgroup = $element.find('optgroup[data-options-target="default"]');
                    }

                    //deselect default selected value
                    $optgroup.find(':selected').prop('selected', false);
                    let $option = $optgroup.find('option[value="' + value + '"]');

                    //if default optgroup also does not exist
                    //then the select does not have optgroups, so we select the
                    //option directly
                    if ($optgroup.length === 0) {
                        $option = $element.find('option[value="' + value + '"]');
                    }

                    $option.attr('selected', 'selected');
                } else if (elementType === 'INPUT') {
                    const valueType = $element.data('value-type');
                    if (valueType === 'boolean' || $element.prop('type') === 'checkbox') {
                        //For some reason jquery does not accept false as string
                        if (testIsFalseish(value)) {
                            value = false;
                        }

                        $element.prop('checked', value);
                    } else if (valueType === 'integer' || valueType === 'string' || valueType === 'float') {
                        $element.val(value);
                    }
                }
            }

            // make sure the conversion options UI is updated
            conversionOptions.updateOptionsForDropDown(uploader);
        }

        if (config.operation === 'convertToPdfA' || config.operation === 'validatePdfa') {
            import(
                /* webpackMode: "lazy" */
                '../../qaamgo/modules/sat/pdfa-selector'
            ).then(function () {});
        } else if (config.operation === 'compareimage') {
            import(
                /* webpackMode: "lazy" */
                '../../qaamgo/modules/sat/compare-things-selector'
            );
        } else if (config.operation === 'deletepdfassets') {
            import(
                /* webpackMode: "lazy" */
                '../../qaamgo/modules/sat/metadata2go/delete-pdf-assets'
            );
        } else {
            if ($('#MultipleLanguages').length !== 0) {
                import(
                    /* webpackMode: "lazy" */
                    '../../qaamgo/modules/sat/ocr-multiselect'
                ).then(function () {});
            }
        }

        /**
         * @param {jQuery} $element
         *
         * @return {Boolean}
         */
        function isElementWithinView($element) {
            var elementTop = $element.offset().top;
            var elementBottom = elementTop + $element.outerHeight();
            var viewPortTop = $(window).scrollTop();
            var viewPortBottom = viewPortTop + $(window).height();

            return elementBottom > viewPortTop && elementTop < viewPortBottom;
        }

        featureHelper.enableSubmit();

        return uploader;
    },

    checkForBrokenSelects: function (target) {
        var selects = [
            $('select[name="reader"]'),
            $('select[name="audio_codec"]'),
            $('select[name="frequency"]'),
            $('select[name="audio_bitrate"]'),
            $('select[name="audio_vbr"]'),
            $('select[name="codec"]'),
            $('select[name="rounds"]'),
            $('select[name="preset"]'),
        ];

        selects.forEach((/** JQuery */ $select, idx) => {
            if ($select.length !== 1) {
                return;
            }

            const helper = new SelectHelper($select);

            if (!helper.isVisible()) {
                return;
            }

            const $optGroups = helper.getOptGroups();

            if ($optGroups.length === 0) {
                return;
            }

            let numberOfVisible = helper.getNumberOfVisibleOptGroups();

            if (numberOfVisible !== 1) {
                globalLogger.log('select checker - wrong number of visible opt groups', numberOfVisible);

                return;
            }

            const hasTargetOptGroup = helper.hasOptGroupbyTarget(target);

            const selectedTarget = helper.getSelectedTargetFromSelect();

            if (hasTargetOptGroup) {
                if (selectedTarget !== target) {
                    globalLogger.log(
                        'select checker - selected wrong target',
                        `actual: "${target}" selected "${selectedTarget}"`
                    );
                }
            } else {
                if (selectedTarget !== 'default') {
                    globalLogger.log(
                        'select checker - does not contain target but did not select default',
                        `selected "${selectedTarget}"`
                    );
                }
            }
        });
    },
    startWithConversion: function (conversionOptions, targetPath, jobId = null) {
        window.allowLeave = true;

        if (testIsNull(jobId)) {
            jobId = uploader.getJob().getId();
        }

        api.addConversionWithCheck(jobId, conversionOptions)
            .done(function (response) {
                globalLogger.log('modConversion add done', { info: JSON.stringify(conversionOptions) });

                window.location = targetPath + '#j=' + jobId;
            })
            .fail(function (apiError, response) {
                if (apiError === API_ERROR_PAYMENT_REQUIRED) {
                    limitReachedStartConversion(response);

                    window.paymentConversion = { active: true };

                    return;
                }

                globalLogger.log('modConversion add fail', {
                    info: 'error: ' + apiError + ' data: ' + JSON.stringify(conversionOptions),
                });
            });
    },
    showRelevantOptionsForTarget: conversionOptions.showRelevantOptionsForTarget,
    getOptionsFromForm: conversionOptions.getConversionOptionsFromForm,
    setupTargetDropDown: conversionOptions.setupTargetDropDown,
    updateConversionOptionsForDropDown: conversionOptions.updateOptionsForDropDown,
    defaultSubmit: featureHelper.defaultSubmitFunction,
    getValueFromCurrentUrl: getValueFromCurrentUrl,
    highlightRadioButtons: conversionOptions.highlightRadioButtons,
    /**
     * Checks the current url for gdrive files and adds them to the uploader
     *
     * @param {Uploader} uploader
     */
    addGdriveFilesFromQuery: function (uploader) {
        try {
            // this is the 'old' way which sends just one file
            const g_filename = getValueFromCurrentUrl('g_filename');
            const g_token = getValueFromCurrentUrl('g_token');
            const g_fileid = getValueFromCurrentUrl('g_fileid');
            const g_mimetype = getValueFromCurrentUrl('g_mimetype');

            if (
                typeof g_filename === 'string' &&
                typeof g_token === 'string' &&
                typeof g_fileid === 'string' &&
                typeof g_mimetype === 'string'
            ) {
                uploader.addGdrive(g_filename, g_token, g_fileid, g_mimetype);

                return;
            }

            const gDriveFiles = getValueFromCurrentUrl('gdrive_files');

            if (!testIsNonEmptyString(gDriveFiles)) {
                return;
            }

            let files = null;

            try {
                let decoded = '';
                decoded = decodeURIComponent(gDriveFiles);
                files = JSON.parse(decoded);
            } catch (e) {
                return;
            }

            /** @type {Array} */
            if (!testIsArray(files)) {
                window.qgLogger.log('add gdrive files - fail - invalid data', gDriveFiles);

                return;
            }

            for (var idx = 0; idx < files.length; idx++) {
                /** @type {Object} */
                var d = files[idx];

                if (
                    typeof d.name === 'string' &&
                    typeof d.token === 'string' &&
                    typeof d.fileid === 'string' &&
                    typeof d.mimetype === 'string'
                ) {
                    uploader.addGdrive(d.name, d.token, d.fileid, d.mimetype);
                } else {
                    window.qgLogger.log('add gdrive files - fail - invalid data', gDriveFiles);
                }
            }
        } catch (e) {
            window.qgLogger.log('add gdrive files - fail - exception', e);
        }
    },
    /**
     * Checks the current url for ?j= and adds its inputs to the uploader
     *
     * @param {Uploader} uploader
     */
    addJobFilesFromQuery: function (uploader) {
        try {
            var idJob = getValueFromCurrentUrl('j');

            if (typeof idJob !== 'string') {
                return;
            }

            api.getJobInfoWithRetries(idJob).done(function (jobInfo) {
                for (let inputId in jobInfo.input) {
                    uploader.addInputId(jobInfo.input[inputId].id);
                }
            });
        } catch (e) {
            window.qgLogger.log('add job by id - fail - exception', e);
        }
    },
    /**
     * Checks the current url for ?su= and adds its inputs to the uploader
     *
     * @param {Uploader} uploader
     */
    addStorageFilesFromQuery: function (uploader) {
        try {
            var idStorage = getValueFromCurrentUrl('su');

            if (typeof idStorage !== 'string') {
                return;
            }

            api.ajaxWrapper
                .get({
                    url: satGlobals.getApiUrl('api/storage/url/' + idStorage),
                    dataType: 'json',
                    xhrFields: {
                        withCredentials: true,
                    },
                    cache: false,
                    maxRetries: 3,
                })
                .done(function (response) {
                    for (let storageItem in response.items) {
                        uploader.addExternalUrl(response.items[storageItem].url);
                    }
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    globalLogger.log('get storage data - fail - connection problem', {
                        http_status: jqXHR.status,
                        ajax_status: textStatus,
                        ajax_error: errorThrown,
                    });
                });
        } catch (e) {
            window.qgLogger.log('add job by storage - fail - exception', e);
        }
    },
};
